if (!customElements.get("m-announcement-bar")) {
  class MAnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const enableSlider = this.dataset.enableSlider === "true";
      if (!enableSlider) return;
      this.initSlider();
    }

    initSlider() {
      const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      const autoplay = this.dataset.enableAutoplay === "true" && !reduceMotion;
      const autoplaySpeed = Number.parseFloat(this.dataset.autoplaySpeed) || 3.5;
      const slideContainer = this.querySelector(".swiper-container");
      if (slideContainer) {
        this.slider = new MinimogLibs.Swiper(slideContainer, {
          direction: this.dataset.sliderAxis === "vertical" ? "vertical" : "horizontal",
          slidesPerView: 1,
          slidesPerGroup: 1,
          autoHeight: false,
          speed: 420,
          autoplay: autoplay
            ? {
                delay: autoplaySpeed * 1000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }
            : false,
          loop: true,
          navigation: {
            nextEl: this.querySelector(".swiper-button-next"),
            prevEl: this.querySelector(".swiper-button-prev"),
          },
        });
      }
    }
  }

  customElements.define("m-announcement-bar", MAnnouncementBar);
}
